import i18n from './i18n';

export const FlashDefinition = {
  contentCopiedSuccess: {
    context: [{ detail: i18n.contentCopied }],
    status: 'success',
  },
};
